import { TimerCallback } from '@commons/core/format/models/timer';
import { RxUtil } from '@commons/util/utilities/rx';
import { Actions, ofType } from '@ngrx/effects';
import { IPromise, IQService } from 'angular';
import { combineLatest, first, map, merge, mergeMap, Observable, of, throwError, withLatestFrom } from 'rxjs';

import {
  BookingFacade,
  FormFacade,
  isNotNullOrUndefined,
  Qualification,
  QualificationAction,
  QualificationFacade,
  QualificationService,
  TimerService,
} from '@contact/upgrade';

const MODULE_NAME = 'qualificationDeprecatedService';

/**
 *  @deprecated, prefer BookingFacade
 */
export interface IQualificationDeprecatedService {
  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  getConfiguration(responseId: string): IPromise<Qualification | undefined>;

  /**
   *  @deprecated, prefer BookingFacade.renew
   */
  renewPostTreatment(responseId: string): IPromise<any>;

  /**
   *  @deprecated, prefer BookingFacade.stop
   */
  finishQualification(responseId: string): IPromise<any>;

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  canFinishQualification(responseId: string): IPromise<boolean>;

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  canRenewPostTreatment(responseId: string): IPromise<boolean>;

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  canFinishPostTreatment(responseId: string): Observable<boolean>;

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  isRatingCallQualityEnabled(responseId: string): IPromise<boolean>;

  /**
   *  @deprecated, prefer TimerService.timer
   */
  startPostTreatment(responseId: string, callback: TimerCallback): void;

  /**
   *  @deprecated, prefer TimerService.timer
   */
  startPostTreatmentReprieve(responseId: string, callback: TimerCallback): void;
}

/**
 *  @deprecated, prefer BookingFacade
 */
export class QualificationDeprecatedService implements IQualificationDeprecatedService {
  static $inject: Array<string> = ['$q', 'timerService', 'contactFacade', 'formFacade', 'qualificationFacade', 'ngrxActionService'];

  public name = MODULE_NAME;

  constructor(
    private readonly $q: IQService,
    private readonly timerService: TimerService,
    private readonly contactFacade: BookingFacade,
    private readonly formFacade: FormFacade,
    private readonly qualificationFacade: QualificationFacade,
    private readonly actions$: Actions
  ) {}

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  getConfiguration(responseId: string): IPromise<Qualification | undefined> {
    const ob$ = of({}).pipe(
      withLatestFrom(this.contactFacade.getQualifById(responseId), (_, qualification) => qualification),
      isNotNullOrUndefined()
    );
    return RxUtil.toPromise(ob$, this.$q);
  }

  /**
   *  @deprecated, prefer BookingFacade.renew
   */
  renewPostTreatment(responseId: string): IPromise<any> {
    this.contactFacade.renewQualif(responseId);
    const success$ = this.actions$.pipe(ofType(QualificationAction.RenewSuccess), first());
    const fail$ = this.actions$.pipe(
      ofType(QualificationAction.RenewFail),
      mergeMap(() => throwError(() => 'fail'))
    );
    return RxUtil.toPromise(merge(success$, fail$), this.$q);
  }

  /**
   *  @deprecated, prefer BookingFacade.stop
   */
  finishQualification(responseId: string): IPromise<any> {
    this.contactFacade.stopQualif(responseId);
    const success$ = this.actions$.pipe(ofType(QualificationAction.StopSuccess), first());
    const fail$ = this.actions$.pipe(
      ofType(QualificationAction.StopFail),
      mergeMap(() => throwError(() => 'fail'))
    );
    return RxUtil.toPromise(merge(success$, fail$), this.$q);
  }

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */

  canFinishQualification(responseId: string): IPromise<boolean> {
    const ob$ = of({}).pipe(
      withLatestFrom(this.contactFacade.getQualifById(responseId), (_, qualification) => qualification),
      map(qualification => !!qualification && qualification.canInterrupt)
    );
    return RxUtil.toPromise(ob$, this.$q);
  }

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  canRenewPostTreatment(responseId: string): IPromise<boolean> {
    const ob$ = of({}).pipe(
      withLatestFrom(this.contactFacade.getQualifById(responseId), (_, qualification) => qualification),
      map(qualification => !!qualification && qualification.nbRenewable > 0 && qualification.renewableDuration > 0)
    );
    return RxUtil.toPromise(ob$, this.$q);
  }

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  canFinishPostTreatment(responseId: string): Observable<boolean> {
    const qualification$ = this.qualificationFacade.getById(responseId);
    const qualificationValid$ = this.formFacade.isValid(QualificationService.toFormId(responseId));
    return combineLatest([qualification$, qualificationValid$]).pipe(map(([qualif, valid]) => !!qualif && qualif.canInterrupt && valid));
  }

  /**
   *  @deprecated, prefer BookingFacade.getContact
   */
  isRatingCallQualityEnabled(responseId: string): IPromise<boolean> {
    const ob$ = of({}).pipe(
      withLatestFrom(this.contactFacade.getQualifById(responseId), (_, qualification) => qualification),
      map(qualification => !!qualification && qualification.ratingQualityEnabled)
    );
    return RxUtil.toPromise(ob$, this.$q);
  }

  /**
   *  @deprecated, prefer TimerService.timer
   */
  startPostTreatment(responseId: string, callback: TimerCallback): void {
    this.timerService.timer(QualificationService.toTimerId(responseId)).subscribe({
      next: value => callback(value),
      complete: () => callback(0),
    });
  }

  /**
   *  @deprecated, prefer TimerService.timer
   */
  startPostTreatmentReprieve(responseId: string, callback: TimerCallback): void {
    this.timerService.timer(QualificationService.toTimerId(responseId)).subscribe({
      next: value => callback(value),
    });
  }
}

export default MODULE_NAME;
